/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramUsersControllerPatchEmailMutationRequest,
  TelegramUsersControllerPatchEmailMutationResponse,
  TelegramUsersControllerPatchEmail400,
  TelegramUsersControllerPatchEmail401,
  TelegramUsersControllerPatchEmail429,
} from '../types/TelegramUsersControllerPatchEmail.ts';

function getTelegramUsersPatchEmailUrl() {
  const res = { method: 'PATCH', url: `/api/telegram/users/email` as const };
  return res;
}

/**
 * {@link /api/telegram/users/email}
 */
export async function telegramUsersPatchEmail(
  data: TelegramUsersControllerPatchEmailMutationRequest,
  config: Partial<RequestConfig<TelegramUsersControllerPatchEmailMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramUsersControllerPatchEmailMutationResponse,
    ResponseErrorConfig<
      TelegramUsersControllerPatchEmail400 | TelegramUsersControllerPatchEmail401 | TelegramUsersControllerPatchEmail429
    >,
    TelegramUsersControllerPatchEmailMutationRequest
  >({ method: 'PATCH', url: getTelegramUsersPatchEmailUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
